/**
 * Takes a snake_case string and returns a human readable string
 *
 * @param {string} input - ie. some_string
 * @returns {string} - ie. Some String
 */
export function snakeCaseToHumanReadable(input) {
  if (typeof input !== 'string') {
    throw new Error('input must be a string');
  }
  const words = input.split('_');
  const formatted = [];
  for (const w of words) {
    formatted.push(w.charAt(0).toUpperCase() + w.slice(1));
  }
  return formatted.join(' ');
}
